import { ApiErrorResponse } from "../types/common";
import { ApiTaxonomy } from "../types/taxonomy";
import { AbstractBaseApi, ApiMethod, Params, RequestResponseType, SupportedContentType } from "./AbstractBaseApi";

export class TaxonomyApi extends AbstractBaseApi {
  private static TAXI_ENDPOINT = "/taxonomies";

  public constructor (authString: string) {
    super({
      authString: authString
    })
  }

  public async get(id: string): Promise<ApiTaxonomy> {
    return this.makeApiRequest<SupportedContentType.Json, ApiTaxonomy>(
      ApiMethod.Get,
      `${TaxonomyApi.TAXI_ENDPOINT}/${id}`,
      true,
      SupportedContentType.Json,
      undefined,
      undefined,
      undefined,
      SupportedContentType.Json,
    );
  }

  public async save(taxo: ApiTaxonomy): Promise<void> {
    return this.makeApiRequest<SupportedContentType.Json, void>(
      ApiMethod.Post,
      `${TaxonomyApi.TAXI_ENDPOINT}`,
      true,
      SupportedContentType.Json,
      undefined,
      undefined,
      JSON.stringify(taxo),
      SupportedContentType.Json,
    );
  }

  protected async makeApiRequest<ResponseContentType extends SupportedContentType, T>(
    method: ApiMethod,
    endPoint: string,
    requiresAuth: boolean,
    responseContentType: ResponseContentType,
    queryParams?: Params,
    customHeaders?: Params,
    postBody?: string,
    requestContentType?: SupportedContentType,
  ): Promise<RequestResponseType<ResponseContentType, T>> {
    const uri = this.buildUri(endPoint, queryParams || {});
    const options = this.buildOptions(
      endPoint,
      method,
      customHeaders || {},
      postBody || null,
      requestContentType || SupportedContentType.Json,
      requiresAuth,
    );
    const response = await window.fetch(uri, options);
    // handle non 200 responses
    if (!response.ok) {
      if (response.headers.get("content-type")?.startsWith(SupportedContentType.Json)) {
        let errorResponse;
        try {
          errorResponse = await response.json();
          if (!errorResponse || !errorResponse.response) {
            throw new Error();
          }
        } catch (err) {
          throw new Error("Unexpected error with API call, response is not JSON.");
        }
        let responseObject: ApiErrorResponse<any> = errorResponse.response;
        if (
          typeof errorResponse.response === "object" &&
          errorResponse.response !== null &&
          !Array.isArray(errorResponse.response)
        ) {
          responseObject = errorResponse.response;
        }
        const error = new Error(responseObject.message);
        (error as any).source = responseObject;
        throw error;
      }
      throw new Error("Unexpected error with API call, response is not JSON.");
    }
    switch (responseContentType) {
      case SupportedContentType.Binary:
      case SupportedContentType.Png:
        return response.blob() as any;
      case SupportedContentType.Text:
      case SupportedContentType.Xml:
        return response.text() as any;
      case SupportedContentType.Json:
      default:
        const toReturn = await response.json();

        return toReturn;
    }
  }

}
